var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86039 5.99297L11.4095 10.5419C11.6392 10.7716 11.6392 11.1501 11.4095 11.3798L11.3846 11.4046C11.1549 11.6343 10.7765 11.6343 10.5468 11.4046L5.99766 6.84933L1.44872 11.4046C1.21903 11.6343 0.840543 11.6343 0.610846 11.4046L0.585998 11.3798C0.35024 11.1501 0.35024 10.7716 0.585998 10.5419L5.13509 5.99282L0.585998 1.44388C0.356452 1.21419 0.356452 0.835701 0.585998 0.606005L0.610846 0.581156C0.840543 0.35146 1.21903 0.35146 1.44872 0.581156L5.99766 5.13024L10.5468 0.581307C10.7765 0.351611 11.1549 0.351611 11.3846 0.581307L11.4095 0.606156C11.6392 0.835853 11.6392 1.21434 11.4095 1.44403L6.86039 5.99297Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMClose);
export default __webpack_public_path__ + "static/media/mClose.2492dece.svg";
export { ForwardRef as ReactComponent };